var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"achievement"},[_c('img',{staticClass:"achievement__image",attrs:{"src":_vm.image,"alt":_vm.title,"lazy":"load","decode":"async"}}),_c('p',{staticClass:"achievement__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }